export const PSI_ACCESS_DISABLED_CODE = 9004
/** PSI 未开通时客户端本地预校验使用的统一用户提示。 */
export const PSI_ACCESS_DISABLED_MESSAGE =
  '当前企业暂未开通私域管家服务，请联系企业管理员开通后再使用。'
export const PSI_ACCESS_DISABLED_EVENT = 'psi-access-disabled'
export const PSI_ACCESS_CHANGED_EVENT = 'psi:access:changed'

export type PsiAccessStatus = 'unknown' | 'enabled' | 'disabled'

export interface PsiAccessChangedPayload {
  status: PsiAccessStatus
  apiBase: string
  companyId: number
  userId: number
  serverEnv: string
  sourceId?: string
}
